import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from '@traction/shared';
import { useAuth } from '@/contexts/AuthContext';
import { getSupabaseClient } from '@traction/api-client';
import { useEffect, useState } from 'react';

export function AdminRoute() {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function checkAdminRole() {
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await getSupabaseClient()
          .from('users')
          .select('role')
          .eq('id', user.uid)
          .single();

        if (error) throw error;
        const userData = data as { role: string } | null;
        setIsAdmin(userData?.role === 'super_admin' || userData?.role === 'admin');
      } catch {
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    }

    if (!authLoading) {
      checkAdminRole();
    }
  }, [user, authLoading]);

  if (authLoading || loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-200 border-t-black" />
      </div>
    );
  }

  if (!user || !isAdmin) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
}
